import React from 'react';
import { Modal, Row, Col, Input, message } from 'antd';
import API_URL from '../../../common/url';
import $ from '../../../common/AjaxRequest';
import TableC from '../../basicElement/TableC';

const TextArea = Input.TextArea;

class AcLogTable extends React.Component {
    state = {
        visible: false,
        loading: false,
        remark: "",
        data: []
    }

    show = investigationId => {
        this.setState({
            investigationId,
            visible: true,
        }, () => { this.loadData() });
    }

    hide = () => {
        this.setState({ visible: false });
    }

    handleChange = (e) => {
        this.setState({
            remark: e.target.value
        });
    }

    loadData = () => {
        const { investigationId } = this.state;
    

        $.sendRequest({
            method: 'POST',
            url: API_URL.sumtotal.queryAcLogByInvId,
            data: { investigationId },
            dataType: 'json',
            doneResult: res => {
                this.setState({
                    loading: false,
                    data: res.data || {}
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            },

        });
    }


    getColumns = () => {
        const columns = [{
            title: '操作人',
            dataIndex: 'userName',
            key: 'userName',
            width: 130
        }, {
            title: '操作时间',
            dataIndex: 'createTime',
            key: 'createTime',
            width: 130
        }, {
            title: '操作内容',
            dataIndex: 'workType',
            key: 'workType',
            width: 130
        }, {
            title: '备注说明',
            dataIndex: 'remark',
            key: 'remark',
            width: 230
        }];
        return columns;
    }



    render() {
        const { visible, loading, remark, data } = this.state;
        return (
            <Modal
                title="AC开关日志"
                visible={visible}
                onOk={this.hide}
                onCancel={this.hide}
                className="create-modal"
                wrapClassName="vertical-center-modal"
                width="650px"
                loading={loading}
            >
                <TableC
                    scrollY={220}
                    data={data}
                    columns={this.getColumns()}
                />
            </Modal>
        );
    }
}

export default AcLogTable;


// WEBPACK FOOTER //
// ./src/components/sumTotal/projectPercent/AcLogTable.js